<div class="toolbox">
  <!-- left -->
  <div class="toolbox-l">
    @if (toolboxLeftTpl() != null) {
      <ng-container
        *ngTemplateOutlet="toolboxLeftTpl(); context: { dataSource: dataSource, selection: selection }"
      ></ng-container>
    }
  </div>

  <!-- right -->
  <div class="toolbox-r">
    @if (toolboxRightTpl() != null) {
      <ng-container
        *ngTemplateOutlet="toolboxRightTpl(); context: { dataSource: dataSource, selection: selection }"
      ></ng-container>
    }
  </div>
</div>
<div class="table-container cbre-table-container">
  <!-- toolbox -->

  <!-- TABLE -->
  <mat-table
    id="{{ tableId() }}Table"
    [dataSource]="dataSource"
    matSort
    class="cbre-table"
    [ngStyle]="{ 'max-height': maxHeight() }"
    [ngClass]="{ 'cbre-table--empty': dataSource?.data?.length === 0 }"
    >
    <!-- TABLE SELECTION -->
    @if (selectionMode() != null) {
      <ng-container [matColumnDef]="SELECT_CELL_COLUMN_DEF" sticky>
        <!-- SELECT ALL CHECKBOX -->
        <th mat-header-cell *matHeaderCellDef scope="col">
          @if (selectionMode() === 'multi' && elements().length) {
            <mat-checkbox
              id="{{ tableId() }}Table_chkSelectAll"
              [checked]="isAllSelected"
              [indeterminate]="isIndeterminate"
              [aria-label]="checkboxLabel()"
              (change)="$event ? selectAllToggle() : null"
              >
            </mat-checkbox>
          }
        </th>
        <td mat-cell *matCellDef="let row">
          <!-- SELECT EACH ROW CHECKBOX -->
          <mat-checkbox
            id="{{ tableId() }}Table_chkSelectRow"
            [checked]="selection?.isSelected(row)"
            [aria-label]="checkboxLabel(row)"
            (click)="$event.stopPropagation()"
            (change)="$event ? selectionToggle(row) : null"
            >
          </mat-checkbox>
        </td>
      </ng-container>
    }

    <!-- ACTIONS CELL DEFINITION -->
    @if (cellEventsTpl() != null) {
      <ng-container [matColumnDef]="EVENT_CELL_COLUMN_DEF">
        <th mat-header-cell *matHeaderCellDef scope="col">
          @if (headerEventsTpl() != null) {
            <ng-container
              *ngTemplateOutlet="headerEventsTpl(); context: { row: row, selection: selection }"
            ></ng-container>
          }
        </th>
        <td mat-cell *matCellDef="let row">
          <ng-container *ngTemplateOutlet="cellEventsTpl(); context: { row: row, selection: selection }"></ng-container>
        </td>
      </ng-container>
    }

    <!-- EACH COLUMN DEF -->
    @for (column of columns(); track trackColumn(column)) {
      <!-- COLUMN TEMPLATES -->
      <ng-container [matColumnDef]="column.path ?? column.field" [sticky]="!!column.sticky">
        <!-- TH HEADER -->
        <th
          mat-header-cell
          *matHeaderCellDef
          scope="col"
          mat-sort-header
          [disabled]="!column.sortable"
          id="{{ tableId() }}Table_headerColumn{{ column.columnId }}"
          >
          {{ column.header }} @if (column.required) {
          <span class="required-icon"> * </span>
        }
        @if (column.tooltip) {
          <div class="controls-table-column-tooltip">
            <mat-icon [matTooltip]="column.tooltip" matTooltipPosition="above" svgIcon="unknown"></mat-icon>
          </div>
        }
      </th>
      <!-- TD DEF -->
      <td mat-cell *matCellDef="let row" id="{{ tableId() }}Table_column{{ column.columnId }}">
        <!-- if CellRenderer is configured render it else use given template or default template -->
        @if (column.CellRenderer != null) {
          <cbre-cell-renderer [data]="row" [config]="column"></cbre-cell-renderer>
        } @else {
          <!-- USE GIVEN TEMPLATE OR DEFAULT -->
          @if (cellRendererTpl() != null) {
            <!-- RENDER GIVEN TEMPLATE COL DEF -->
            <ng-container
              *ngTemplateOutlet="cellRendererTpl(); context: { row: row, column: column, selection: selection }"
            ></ng-container>
          } @else {
            <span [matTooltip]="row | rowColumnTooltip: column" matTooltipPosition="right">
              {{ row[column.path || column.field] }}
            </span>
          }
        }
      </td>
    </ng-container>
  }

  <!-- ROW TEMPLATES -->

  <!-- HEADER TPL -->
  <tr
    mat-header-row
      *matHeaderRowDef="
        columns()
          | toDisplayedColumns: { isCellEventsPresent: !!cellEventsTpl(), isSelectionModeOn: selectionMode() != null };
        sticky: stickyHeader()
      "
  ></tr>

  <!-- ROW DATA TPL -->
  <tr
    mat-row
    id="{{ tableId() }}Table_row{{ row.id }}"
      *matRowDef="
        let row;
        columns: columns()
          | toDisplayedColumns: { isCellEventsPresent: !!cellEventsTpl(), isSelectionModeOn: selectionMode() != null }
      "
      [ngClass]="{
        disabled: row | isRowDisabled: selectionHandler?.isSelectionDisabled,
        'mat-mdc-row--clickable': isRowClickable(),
      }"
      [matTooltip]="
        (row | isRowDisabled: selectionHandler?.isSelectionDisabled) ? selectionHandler?.disableRowTooltip : ''
      "
    [class]="row.rowClass"
    (click)="handleRowClick(row)"
  ></tr>

  <!-- NO DATA TPL -->
  <tr class="mat-row cbre-table--no-data-row" *matNoDataRow>
    <td
        [attr.colspan]="
          columns().length + (selectionMode() != null || headerEventsTpl() != null || cellEventsTpl() != null ? 1 : 0)
        "
      >
      {{ noDataLabel() }}
    </td>
  </tr>

  <!-- Row shown when there is no matching data. -->
</mat-table>
</div>
@if ((elements().length > 10 || totalCount() > 10) && !hidePaginator()) {
  <mat-paginator
    class="cbre-paginator"
    #controlTablePaginator
    [length]="totalCount() ?? elements().length"
    [pageSize]="pageSize()"
    [pageSizeOptions]="pageSizeOptions()"
    [selectConfig]="paginatorSelectConfig()"
    (page)="pageChange.emit($event)"
    [showFirstLastButtons]="showFirstLastButtons()"
  ></mat-paginator>
}
